export const SORT_DIRECTION = {
  ascend: 'ASC',
  descend: 'DESC',
};